import React, { createContext, useContext, useState } from 'react';
import ContactModal from '../components/ContactModal';

const ContactContext = createContext();

export const useContact = () => {
  const context = useContext(ContactContext);
  if (!context) {
    throw new Error('useContact must be used within ContactProvider');
  }
  return context;
};

export const ContactProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [contactData, setContactData] = useState({});
  const [onSubmitCallback, setOnSubmitCallback] = useState(null);

  const openContact = (data = {}, onSubmitSuccess = null) => {
    setContactData(data);
    if (onSubmitSuccess) {
      setOnSubmitCallback(() => onSubmitSuccess);
    } else {
      setOnSubmitCallback(null);
    }
    setIsOpen(true);
  };

  const closeContact = () => {
    setIsOpen(false);
    setTimeout(() => {
      setContactData({});
      setOnSubmitCallback(null);
    }, 300);
  };

  return (
    <ContactContext.Provider value={{ openContact, closeContact }}>
      {children}
      <ContactModal 
        isOpen={isOpen} 
        onClose={closeContact} 
        initialData={contactData}
        onSubmitSuccess={onSubmitCallback}
      />
    </ContactContext.Provider>
  );
};

